// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20b_G","option":"styles_option__3NZQw","selected":"styles_selected__2gJwC"};